import { Flex } from "antd";
import { useOutletContext } from "react-router-dom";
import { useActivitiesTab } from "@/entities/activities-tab-content/model";
import { AppForm, AppLoader } from "@/shared/Components";
import { ProfessionalActivitiesList } from "../professional-activities-list/ProfessionalActivitiesList";
import { EducationsList } from "../educations-list";
import { CompetencesList } from "../competences-list/CompetencesList";
import { HobbiesList } from "../hobbies-list/HobbiesList";
import { CareersList } from "../careers-list";
import styles from "./styles.module.scss";

const defaultContext = {
  isEditMode: false,
  handleEditMode: () => {},
};

export const ActivitiesDesktop = () => {
  const { isEditMode, handleEditMode } =
    useOutletContext<{
      isEditMode: boolean;
      handleEditMode: () => void;
    }>() ?? defaultContext;

  const { state, methods } = useActivitiesTab(isEditMode);

  const { isLoading, form, personId, addDisabled } = state;
  const { handleSubmit } = methods;

  if (isLoading) {
    return <AppLoader />;
  }

  return (
    <div className={styles.container}>
      <AppForm formApi={form} onSubmit={handleSubmit}>
        <Flex wrap="wrap" gap="clamp(2rem, 5vw, 4rem)">
          <ProfessionalActivitiesList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <CareersList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <EducationsList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <CompetencesList
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
            personId={personId ?? ""}
          />
          <HobbiesList
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
            personId={personId ?? ""}
          />
        </Flex>
      </AppForm>
    </div>
  );
};
